import { FC } from "react";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal/index";
import { Span, SubTitle, Text } from "utils/styling/typography.styled";
import { Container, ModalContainer } from "./DeleteAllModal.styled";
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  deleteCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}
export const DeleteAllConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  isOpen,
  deleteCount,
  onConfirm,
  onCancel
}) => {
  return <Modal open={isOpen} handleBackdropClick={onCancel} disableBackdropClick data-sentry-element="Modal" data-sentry-component="DeleteAllConfirmationModal" data-sentry-source-file="index.tsx">
            <ModalContainer data-sentry-element="ModalContainer" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">Confirm Deletion</SubTitle>
                <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">
                    Are you sure you want to delete ({deleteCount}) images?
                </Text>
                <hr />
                <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
                    <Button onClick={onConfirm} variant={ButtonType.PRIMARY} type="button" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Confirm</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.ERROR} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </Container>
            </ModalContainer>
        </Modal>;
};